module.exports = __webpack_public_path__ + "img/discover.71dfc3b5.svg";